// SPDX-License-Identifier: AGPL-3.0-or-later

import {SpammerOverrideMenuItems} from '@app/features/ui/action_menu/items/SpammerOverrideMenuItems';
import {StaffUserControlsMenuItems} from '@app/features/ui/action_menu/items/StaffUserControlsMenuItems';
import {MenuGroup} from '@app/features/ui/action_menu/MenuGroup';
import {MenuItemSubmenu} from '@app/features/ui/action_menu/MenuItemSubmenu';
import type {User} from '@app/features/user/models/User';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface StaffDeveloperUserControlsMenuItemProps {
	user: User;
	showStaffControls: boolean;
	showSpammerOverrideControls: boolean;
	developerMode: boolean;
}
export const StaffDeveloperUserControlsMenuItem: React.FC<StaffDeveloperUserControlsMenuItemProps> = observer(
	({user, showStaffControls, showSpammerOverrideControls, developerMode}) => {
		const {t} = useLingui();
		if (!showStaffControls && !showSpammerOverrideControls) {
			return null;
		}
		return (
			<MenuItemSubmenu
				label={t`Developer Tools`}
				render={() => (
					<>
						{showStaffControls && (
							<MenuGroup>
								<MenuItemSubmenu label={t`Staff Controls`} render={() => <StaffUserControlsMenuItems user={user} />} />
							</MenuGroup>
						)}
						{showSpammerOverrideControls && (
							<MenuGroup>
								<MenuItemSubmenu
									label={t`Spam Classification`}
									render={() => <SpammerOverrideMenuItems user={user} developerMode={developerMode} />}
								/>
							</MenuGroup>
						)}
					</>
				)}
			/>
		);
	},
);
